import i18next from 'i18next';

export const GENDERS = {
  male: 'male',
  female: 'female',
};

export const GENDER_OPTIONS = [
  {
    label: i18next.t('tables:female'),
    value: GENDERS.female,
  },
  {
    label: i18next.t('tables:male'),
    value: GENDERS.male,
  },
];
